/**
 * https://www.tapd.cn/69107998/prong/stories/view/1169107998001087231
 * 中东国家 不展示符号(如￥$)
 */
export const middleEast = ["SAR", "AED", "OMR", "BHD", "KWD", "QAR"];

export const transformArrayByFilling = (items: string[], symbol: string) => {
	return items.reduce((result, item: string) => {
		return {
			...result,
			[item]: symbol
		};
	}, {});
};

export const priceGraph = {
	...transformArrayByFilling(
		["USD", "CAD", "CLP", "NZD", "ARS", "COP", "AUD", "HKD"],
		"$"
	),
	...transformArrayByFilling(["CNY", "JPY"], "￥"),
	...transformArrayByFilling(["GBP", "EGP"], "£"),
	...transformArrayByFilling(["NOK", "DKK"], "kr."),
	MXN: "MXN $",
	EUR: "€",
	CHF: "CHF",
	RUB: "p.",
	BRL: "R$",
	SEK: "Kr.",
	KRW: "₩",
	ILS: "₪",
	SGD: "S$",
	INR: "Rs",
	CZK: "Kč",
	PLN: "zł",
	JOD: "JD",
	THB: "฿",
	ZAR: "R"
};
export const getSymbolByCurreny = (currency: string) => {
	return priceGraph[currency] || "";
};
